import Image from "next/image";
import Archiver from "public/images/pricing/business/businessArchiving.svg";
import Trashcan from "public/images/pricing/business/businessTrashcan.svg";
import Scheduler from "public/images/pricing/business/businessScheduler.svg";

const Card = () => {
  return (
    <div className="flex w-full items-end justify-center mt-5">
      <div className="grid sm:grid-cols-3 grid-cols-1 gap-10">
        {/* Slate card */}
        <div className="flex ml-5 w-[90%] sm:w-[389px] h-[200px] bg-brand-slate rounded-lg">
          <div className="flex flex-col w-[325px] ml-5 mt-5">
            <Image
              alt="archiver Icon"
              width={30}
              height={30}
              src={Archiver}
              className="flex items-center w-[30px]"
            />
            <p className="font-bold text-xl">Advanced archiving solutions</p>
            <p className="text-slate-300 mt-0 text-base">
              Download a copy of you data to stay compliant with the current guidelines in your
              jurisdiction.{" "}
            </p>
          </div>
        </div>
        <div className="flex ml-5 w-[90%] sm:w-[389px] h-[200px] bg-brand-slate rounded-lg">
          <div className="flex flex-col w-[325px] ml-5 mt-5">
            <Image
              alt="trashcan Icon"
              width={22}
              height={30}
              src={Trashcan}
              className="flex items-center w-[22px]"
            />
            <p className="font-bold text-xl">Robust Deletion policies</p>
            <p className="text-slate-300 mt-0 text-base">
              Delete anything and everything off your organizations pages with the help of one of
              our privacy experts.{" "}
            </p>
          </div>
        </div>
        <div className="flex ml-5 w-[90%] sm:w-[389px] h-[200px] bg-brand-slate rounded-lg">
          <div className="flex flex-col w-[325px] ml-5 mt-5">
            <Image
              alt="scheduler Icon"
              width={27}
              height={30}
              src={Scheduler}
              className="flex items-center w-[27px]"
            />
            <p className="font-bold text-xl">Presets and automation</p>
            <p className="text-slate-300 mt-0 text-base">
              Save deletions form preset or schedule automated deletion or run it on a later date
              when you need it.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
